import type {Word} from "$lib/classes/data/word";

export let allWords: Word[] = [];

export function setAllWords(value: Word[]) {
  allWords.push(...value)
}

